import React from 'react';
import { Phone, MessageCircle, MapPin, Award, TrendingUp, Users } from 'lucide-react';
import { Button } from './ui/button';
import { AGENT } from '../mock/mock';

const AboutAshish = () => {
  return (
    <section className="py-20 lg:py-24 relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-1/2 left-0 w-[500px] h-[500px] rounded-full bg-purple-200/30 blur-3xl" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] rounded-full bg-violet-200/30 blur-3xl" />
      </div>

      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* Left - Photo/Illustration */}
          <div className="relative">
            <div className="relative rounded-[36px] overflow-hidden premium-shadow bg-gradient-to-br from-[#5F259F] to-[#7C3AED] aspect-[4/5] max-w-[440px] mx-auto">
              <img
                src="https://customer-assets-jai6qajn.emergentagent.net/job_landing-replica-38/artifacts/frqqmsm7_file_0000000057708209b8b5f1b857aedd4a.png"
                alt="Ashish Sharma - Premium Account Executive"
                className="absolute inset-0 w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#3d1568]/85 via-[#3d1568]/10 to-transparent" />

              {/* Floating badges */}
              <div className="absolute top-5 right-5 rounded-2xl px-3 py-2 text-white bg-white/20 border border-white/30 backdrop-blur-xl">
                <div className="text-[10px] font-bold uppercase tracking-wider text-white/90">Verified</div>
                <div className="text-sm font-extrabold">Premium Partner</div>
              </div>

              <div className="absolute bottom-6 left-6 right-6 glass-card rounded-2xl p-4 bg-white/90">
                <div className="text-[11px] font-bold text-[#5F259F] uppercase tracking-wider">{AGENT.tag}</div>
                <div className="text-xl font-extrabold text-slate-900">{AGENT.name}</div>
                <div className="text-[12px] text-slate-600">{AGENT.title}</div>
              </div>
            </div>

            {/* Floating stats */}
            <div className="hidden md:block absolute -top-4 -left-4 glass-card rounded-2xl p-3 floating">
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-xl gradient-primary flex items-center justify-center">
                  <Users className="w-4 h-4 text-white" />
                </div>
                <div>
                  <div className="text-lg font-black text-slate-900 leading-none">1000+</div>
                  <div className="text-[10px] text-slate-500">Merchants</div>
                </div>
              </div>
            </div>
            <div className="hidden md:block absolute -bottom-4 -right-4 glass-card rounded-2xl p-3 floating-delayed">
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-xl gradient-primary flex items-center justify-center">
                  <MapPin className="w-4 h-4 text-white" />
                </div>
                <div>
                  <div className="text-lg font-black text-slate-900 leading-none">20+</div>
                  <div className="text-[10px] text-slate-500">Cities</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-purple-200 soft-shadow">
              <Award className="w-3.5 h-3.5 text-[#5F259F]" />
              <span className="text-[11px] font-bold tracking-wider text-[#5F259F] uppercase">Meet Your Partner</span>
            </div>
            <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-slate-900 leading-[1.1]">
              Your local guide to <span className="gradient-text">PhonePe Business</span>
            </h2>
            <p className="mt-5 text-slate-600 text-[15px] leading-relaxed">
              Ashish is a certified Premium Account Executive with years of experience helping merchants across Himachal Pradesh and Uttarakhand grow their business with digital payments — backed by hands-on installation, training and after-sales care.
            </p>

            <div className="mt-6 grid grid-cols-3 gap-3">
              {[
                { icon: Award, k: '5+', l: 'Years Experience' },
                { icon: Users, k: '1000+', l: 'Merchants Onboarded' },
                { icon: TrendingUp, k: '20+', l: 'Cities Covered' },
              ].map((s, i) => {
                const I = s.icon;
                return (
                  <div key={i} className="bg-white rounded-2xl border border-purple-100 p-4 soft-shadow">
                    <I className="w-5 h-5 text-[#5F259F]" />
                    <div className="mt-2 text-2xl font-black gradient-text leading-none">{s.k}</div>
                    <div className="text-[11px] text-slate-500 mt-1 font-medium">{s.l}</div>
                  </div>
                );
              })}
            </div>

            <div className="mt-7 flex flex-wrap gap-3">
              <Button className="gradient-primary text-white rounded-2xl h-13 px-6 h-12 font-semibold btn-glow border-0">
                <Phone className="w-4 h-4 mr-2" /> Call {AGENT.phone}
              </Button>
              <Button variant="outline" className="rounded-2xl h-12 px-6 border-2 border-emerald-500 text-emerald-600 hover:bg-emerald-50 font-semibold">
                <MessageCircle className="w-4 h-4 mr-2" /> WhatsApp Ashish
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutAshish;
